const createModifyPlayerSelect = (name, showOnValue, options = {}, childName = "player-select") => ({
  name,
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "player.select",
  showOn: [{ state: "editState", value: showOnValue, operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: childName,
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
        excludeOtherEvents: true,
        excludeFrom: "main",
        calculateOnCourt: "after",
        ...options,
      },
      actionGroups: [
        {
          actions: [
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            { action: "calculateOnCourt" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
});

export const ModifyPlayerSelect = createModifyPlayerSelect("player", "player");

export const ModifyBlockPlayerSelect = createModifyPlayerSelect(
  "block-player",
  "block-player",
  { excludeOtherEvents: false },
  "block-player-select",
);
